import './SwitchComponent.css';
import { FormControlLabel, Switch, Tooltip, IconButton, Box } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

type EnableDoubleWinToggleProps = {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  labelSx?: object;
};

export function EnableDoubleWinToggle({
  checked,
  onChange,
  disabled = false,
  labelSx = {},
}: EnableDoubleWinToggleProps) {
  return (
    <FormControlLabel
      control={
        <Switch
          className='root togglePointer'
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      }
      label={
        <Box display='flex' alignItems='center'>
          Enable Double Win
          <Tooltip title="Allows the consumer to win Always Win a prize, even if the consumer already won a prize from Instant Win.">
            <IconButton size='small' sx={{ ml: 1 }}>
              <HelpOutlineIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        </Box>
      }
      sx={labelSx}
    />
  );
}